import React, { useContext } from "react"
import { AdminContext } from "~/contexts/AdminContext"
import { formatMoneyFromCents } from "~/utils/formatMoney"

const OrderStat = ({ label, valueInCents, isLoading }) => {
  const { camp } = useContext(AdminContext)

  const value = ![null, undefined].includes(valueInCents)
    ? formatMoneyFromCents(valueInCents, camp.currency)
    : valueInCents

  return (
    <dl className="max-w-full flex-1">
      <div
        className="overflow-hidden rounded-lg bg-white px-4 py-5 sm:px-4.5 sm:pt-3 sm:pb-3.5 border border-gray-200 shadow-sm"
        title={`${label} \n ${value}`}
      >
        <dt className="truncate text-sm font-medium text-gray-400">{label}</dt>
        <dd className="mt-1 text-2xl font-semibold tracking-tight text-gray-900">
          {![null, undefined].includes(valueInCents) && !isLoading
            ? value
            : <span className="inline-block h-6 w-24 bg-gray-200 animate-pulse"></span>}
        </dd>
      </div>
    </dl>
  )
}

export default OrderStat
